// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".login-register-links[data-v-f92d36c0]{min-width:120px}#login-dropdown[data-v-f92d36c0]{overflow:hidden}@include media-breakpoint-up(sm){.account-nav-icon[data-v-f92d36c0]{height:1.25rem!important;width:auto!important}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
